export default __webpack_public_path__ + "static/media/image03.7817134f.jpg";